export default __webpack_public_path__ + "static/media/cta-bg13.7bec286d.jpg";